var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoteca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d3539;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439,373.19A190.41,190.41,0,0,0,446,322c0-87.4-59.32-161.19-139.81-183.26V111.11A23.14,23.14,0,0,0,283.08,88H266V10a10,10,0,0,0-20,0V88H228.92a23.14,23.14,0,0,0-23.11,23.11v27.63C125.32,160.81,66,234.6,66,322c0,104.77,85.23,190,190,190a188.59,188.59,0,0,0,135.9-57.21,10,10,0,0,0-14.31-14,169.12,169.12,0,0,1-68.17,42.68,150.33,150.33,0,0,0,19.16-29.74A222.73,222.73,0,0,0,341.38,422H367a10,10,0,1,0,0-20H347a341.42,341.42,0,0,0,8.9-70h69.83a170.1,170.1,0,0,1-5.93,35.81A10,10,0,1,0,439,373.19ZM246,490.61c-21.93-6.11-41.4-32-54.2-68.61H246ZM185.76,402a318.41,318.41,0,0,1-9.61-70H246v70ZM86.3,332h69.84a341.51,341.51,0,0,0,8.9,70H106A168.75,168.75,0,0,1,86.3,332ZM106,242h59a341.42,341.42,0,0,0-8.9,70H86.3A168.71,168.71,0,0,1,106,242Zm70.11,70a319,319,0,0,1,9.6-70H246v70ZM266,153.39c21.93,6.11,41.4,32,54.2,68.61H266Zm-20,0V222H191.8C204.6,185.36,224.07,159.5,246,153.39ZM266,242h60.24a318.41,318.41,0,0,1,9.61,70H266Zm81,0h59a168.71,168.71,0,0,1,19.74,70H355.86A341.42,341.42,0,0,0,347,242Zm46.43-20h-52a224.39,224.39,0,0,0-12.8-31.75,149.86,149.86,0,0,0-19.06-29.61A170.73,170.73,0,0,1,393.39,222ZM225.81,132V111.11a3.12,3.12,0,0,1,3.11-3.11h54.16a3.11,3.11,0,0,1,3.11,3.11V132Zm-23.33,28.64a149.86,149.86,0,0,0-19.06,29.61A224.39,224.39,0,0,0,170.62,222h-52a170.73,170.73,0,0,1,83.87-61.36ZM118.61,422h52a224.39,224.39,0,0,0,12.8,31.75,149.86,149.86,0,0,0,19.06,29.61A170.73,170.73,0,0,1,118.61,422ZM266,490.61V422h54.2C307.4,458.64,287.93,484.5,266,490.61ZM326.24,402H266V332h69.85A318.41,318.41,0,0,1,326.24,402Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.1,58.5a10,10,0,0,0,10-10V35.17a10,10,0,0,0-20,0V48.5A10,10,0,0,0,426.1,58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.1,125.17a10,10,0,0,0,10-10V101.83a10,10,0,0,0-20,0v13.34A10,10,0,0,0,426.1,125.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.1,85.17h13.33a10,10,0,0,0,0-20H386.1a10,10,0,0,0,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.77,85.17H466.1a10,10,0,0,0,0-20H452.77a10,10,0,0,0,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,114.67a10,10,0,0,0,10-10V91.33a10,10,0,1,0-20,0v13.34A10,10,0,0,0,50,114.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,181.33a10,10,0,0,0,10-10V158a10,10,0,0,0-20,0v13.33a10,10,0,0,0,10,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,141.33H23.33a10,10,0,0,0,0-20H10a10,10,0,0,0,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.67,141.33H90a10,10,0,0,0,0-20H76.67a10,10,0,1,0,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412,402a10,10,0,1,0,7.07,2.93A10.1,10.1,0,0,0,412,402Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.07,460.29l-34.64-34.64a10,10,0,0,0-14.14,0l-34.64,34.64a10,10,0,0,0,0,14.14l34.64,34.64a10,10,0,0,0,14.14,0l34.64-34.64A10,10,0,0,0,509.07,460.29Zm-41.71,27.57-20.5-20.5,20.5-20.5,20.5,20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.71,425.65a10,10,0,0,0-14.14,0L2.93,460.29a10,10,0,0,0,0,14.14l34.64,34.64a10,10,0,0,0,14.14,0l34.64-34.64a10,10,0,0,0,0-14.14Zm-7.07,62.21-20.5-20.5,20.5-20.5,20.5,20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.93,86.35a10,10,0,0,0,14.14,0l34.64-34.64a10,10,0,0,0,0-14.14L135.07,2.93a10,10,0,0,0-14.14,0L86.29,37.57a10,10,0,0,0,0,14.14ZM128,24.14l20.5,20.5L128,65.14l-20.5-20.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoteca);
export default __webpack_public_path__ + "static/media/Discoteca.26c2b42bdb0e84ee1d316a3c504a0b57.svg";
export { ForwardRef as ReactComponent };